export interface CheckOperationError {
    code?: string;
    message?: string;
    entity?: string;
    entityId?: number;
    field?: string;
}

export type CommunicationStepKey = 'definition' | 'creation' | 'ciblage' | 'offers' | 'validation';

export interface ValidationIssue {
    message: string;
    step: CommunicationStepKey | null;
}

const MESSAGE_BY_CODE: Record<string, string> = {
    COMMUNICATION_SEND_END_REQUIRED: "La date de fin d'envoi est obligatoire lorsque la campagne est envoyable.",
};

const STEP_BY_FIELD_PREFIX: ReadonlyArray<[string, CommunicationStepKey]> = [
    ['DEF_', 'definition'],
    ['TARGET_', 'ciblage'],
    ['CREATION_', 'creation'],
];

const stepFor = (error: CheckOperationError): CommunicationStepKey | null => {
    const field = (error.field ?? '').toUpperCase();
    const fieldStep = STEP_BY_FIELD_PREFIX.find(([prefix]) => field.startsWith(prefix))?.[1];
    if (fieldStep) return fieldStep;
    return (error.entity ?? '').toUpperCase().startsWith('OFFER') ? 'offers' : null;
};

export const toValidationIssues = (errors: CheckOperationError[]): ValidationIssue[] =>
    errors.map(error => ({
        message: (error.code && MESSAGE_BY_CODE[error.code]) || error.message || error.code || 'Erreur de validation',
        step: stepFor(error),
    }));
